const apiContainer = {
  Designation: "/designation",
  Landmark: "/landmark",
  Collections: "/collection",
  ReturnOrder: "/order_return",
  Area: "/area",
  Customer: "/customer",
  Allotment: "/area_allotment",
  Expensecategory: "/item_category",
  Sales: "/order",
  SalesNo: "/order_no",
  SalesDetails: "/orderDetail",
  Draft: "/draft",
  Employee: '/user',
  Branch: '/branch',
  Tally: '/tally',
  Expenses: '/expenses',
  Outstanding: '/outstanding',
  Settings: '/contact_us',
  Product: '/product',
  UserRights: '/user-right',
};

export default apiContainer;
